module.exports = __webpack_public_path__ + "static/media/home-icon.def4a6b1.svg";